import { importMenu } from "./import-menu";
import { deliverySettings } from "./settings";
import { deliveryReport } from "./report";
import { deliveryMenus } from "./menus";
import { syncMenu } from "./sync-menu";

export const delivery = {
	goBack: "Retour",
	updateManyExternalIntegrations: {
		success: "Integrations mises jour avec succs",
	},
	externalStoreIntegrationStatus: {
		synced: "Synchronisé",
		pendingSyncing: "Synchronisation en attente",
		pendingImporting: "Importation en attente",
	},
	deliverySettings,
	deliveryReport,
	deliveryMenus,
	syncMenu,
	importMenu,
};
